// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container div styling */
.pokemon-wrap {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 20px;
    margin-top: 40px;
    font-family: 'Poppins', sans-serif;
}

/* Pokemon card styling */
.pokemon {
    border-radius: 5px;
    border: solid 1px #000;
    padding: 0 10px;
    min-width: 225px;
    transition: ease 0.2s;
}

.pokemon {
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.5);
}

/* Hover over pokemon card style */
.pokemon:hover {
  transform: scale(1.1);
  box-shadow: 0px 10px 20px 2px rgba(0, 0, 0, 0.25);
}

.pokemon a{
    display: flex;
    flex-direction: column;
    text-decoration: none;
    color: #000;
}

.pokemon a .image-and-name {
    display: flex;
    align-items: center;
    justify-content: center;
}

.pokemon-name {
    text-transform: capitalize;
    font-weight: 700;
}

.number {
    font-size: 14px;
    font-weight: 300;
}

.switch-page-buttons {
    margin-top: 40px;
    display: flex;
    justify-content: center;
    gap: 20px;
}

.switch-page-buttons button {
    border: transparent;
    border-radius: 5px;
    background-color: #87CEEB;
    color: #fff;
    font-family: 'Poppins' !important;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
    min-width: 106px;
    transition: ease .3s;
}

.switch-page-buttons button:hover {
    background-color: #4682B4;
}

/* Color of card depending on the type of the pokemon */

/* Ground types */
.pokemon-ground {
    background-color: #8B4513; 
}

/* Water types */
.pokemon-water {
    background-color: #62929E; 
}

/* Fire types */
.pokemon-fire {
    background-color: #F96E46; 
}

/* Fighting types */
.pokemon-fighting {
    background-color: #D84727;
}

/* Flying types */
.pokemon-flying {
    background-color: #87CEEB; 
}

/* Poison types */
.pokemon-poison {
    background-color: #9932CC; 
}

/* Electric types */
.pokemon-electric {
    background-color: #FFD700; 
}

/* Psychic types */
.pokemon-psychic {
    background-color: #FF69B4; 
}

/* Bug types */
.pokemon-bug {
    background-color: #D0E562; 
}

/* Rock types */
.pokemon-rock {
    background-color: #B22222; 
}

/* Ghost types */
.pokemon-ghost {
    background-color: #808080; 
}

/* Dragon types */
.pokemon-dragon {
    background-color: #708090; 
}

/* Dark types */
.pokemon-dark {
    background-color: #000000; 
}

/* Steel types */
.pokemon-steel {
    background-color: #4682B4; 
}

/* Fairy types */
.pokemon-fairy {
    background-color: #FFB6C1; 
}

/* Normal types */
.pokemon-normal {
    background-color: #A9A9A9;
}

/* Ice types */
.pokemon-ice {
    background-color: #ADD8E6; 
}

/* Grass types */
.pokemon-grass {
    background-color: #ACE894; 
}

/* Navigation menu styling */

.header {
    width: 100%;
    transition: .4s ease;
    box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .3), 0 1px 3px 1px rgba(60, 64, 67, .15);
}

.header-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--dark-gray);
    background-color: #fff;
    padding: 0px 20px;
    height: 64px;
    transition: .3s ease;
}

.links-to-pages,
.account-section {
    display: block;
}

.links-to-pages a {
    color: var(--dark-gray);
    font-family: 'Poppins' !important;
    font-size: 16px;
    font-weight: 500;
    text-decoration: none;
    padding: 8px 0;
    margin: 0 15px;
}

.links-to-pages a:hover {
    color: #000;
}

.links-to-pages .active-nav-menu-link {
    border-bottom: 2px solid #4682B4 !important;
    color: #000;
}

/* Styling the logo section */

.landing-page-topbar-logo-section {
    display: flex;
    align-items: center;
    gap: 20px;
}

/* Styling the logo in the logo section */

.landing-page-topbar-logo-section .logo {
    width: 135px;
    display: flex;
    align-items: center;
}

.landing-page-topbar-logo-section .logo img {
    width: 100%;
    padding: 8px;
    border-radius: 4px;
    transition: 0.2s ease;
}

.landing-page-topbar-logo-section .logo img:hover {
    background-color: var(--white);
}`, "",{"version":3,"sources":["webpack://./src/style/PokemonListStyle.css"],"names":[],"mappings":"AAGA,0BAA0B;AAC1B;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;EACE,+CAA+C;AACjD;;AAEA,kCAAkC;AAClC;EACE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,uDAAuD;;AAEvD,iBAAiB;AACjB;IACI,yBAAyB;AAC7B;;AAEA,gBAAgB;AAChB;IACI,yBAAyB;AAC7B;;AAEA,eAAe;AACf;IACI,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB;IACI,yBAAyB;AAC7B;;AAEA,iBAAiB;AACjB;IACI,yBAAyB;AAC7B;;AAEA,iBAAiB;AACjB;IACI,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB;IACI,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,yBAAyB;AAC7B;;AAEA,cAAc;AACd;IACI,yBAAyB;AAC7B;;AAEA,eAAe;AACf;IACI,yBAAyB;AAC7B;;AAEA,gBAAgB;AAChB;IACI,yBAAyB;AAC7B;;AAEA,iBAAiB;AACjB;IACI,yBAAyB;AAC7B;;AAEA,eAAe;AACf;IACI,yBAAyB;AAC7B;;AAEA,gBAAgB;AAChB;IACI,yBAAyB;AAC7B;;AAEA,gBAAgB;AAChB;IACI,yBAAyB;AAC7B;;AAEA,iBAAiB;AACjB;IACI,yBAAyB;AAC7B;;AAEA,cAAc;AACd;IACI,yBAAyB;AAC7B;;AAEA,gBAAgB;AAChB;IACI,yBAAyB;AAC7B;;AAEA,4BAA4B;;AAE5B;IACI,WAAW;IACX,oBAAoB;IACpB,iFAAiF;AACrF;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yCAAyC;IACzC,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,2CAA2C;IAC3C,WAAW;AACf;;AAEA,6BAA6B;;AAE7B;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA,yCAAyC;;AAEzC;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;AAClC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n\n\n/* Container div styling */\n.pokemon-wrap {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n    gap: 20px;\n    margin-top: 40px;\n    font-family: 'Poppins', sans-serif;\n}\n\n/* Pokemon card styling */\n.pokemon {\n    border-radius: 5px;\n    border: solid 1px #000;\n    padding: 0 10px;\n    min-width: 225px;\n    transition: ease 0.2s;\n}\n\n.pokemon {\n  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.5);\n}\n\n/* Hover over pokemon card style */\n.pokemon:hover {\n  transform: scale(1.1);\n  box-shadow: 0px 10px 20px 2px rgba(0, 0, 0, 0.25);\n}\n\n.pokemon a{\n    display: flex;\n    flex-direction: column;\n    text-decoration: none;\n    color: #000;\n}\n\n.pokemon a .image-and-name {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.pokemon-name {\n    text-transform: capitalize;\n    font-weight: 700;\n}\n\n.number {\n    font-size: 14px;\n    font-weight: 300;\n}\n\n.switch-page-buttons {\n    margin-top: 40px;\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n}\n\n.switch-page-buttons button {\n    border: transparent;\n    border-radius: 5px;\n    background-color: #87CEEB;\n    color: #fff;\n    font-family: 'Poppins' !important;\n    font-size: 18px;\n    font-weight: 600;\n    cursor: pointer;\n    min-width: 106px;\n    transition: ease .3s;\n}\n\n.switch-page-buttons button:hover {\n    background-color: #4682B4;\n}\n\n/* Color of card depending on the type of the pokemon */\n\n/* Ground types */\n.pokemon-ground {\n    background-color: #8B4513; \n}\n\n/* Water types */\n.pokemon-water {\n    background-color: #62929E; \n}\n\n/* Fire types */\n.pokemon-fire {\n    background-color: #F96E46; \n}\n\n/* Fighting types */\n.pokemon-fighting {\n    background-color: #D84727;\n}\n\n/* Flying types */\n.pokemon-flying {\n    background-color: #87CEEB; \n}\n\n/* Poison types */\n.pokemon-poison {\n    background-color: #9932CC; \n}\n\n/* Electric types */\n.pokemon-electric {\n    background-color: #FFD700; \n}\n\n/* Psychic types */\n.pokemon-psychic {\n    background-color: #FF69B4; \n}\n\n/* Bug types */\n.pokemon-bug {\n    background-color: #D0E562; \n}\n\n/* Rock types */\n.pokemon-rock {\n    background-color: #B22222; \n}\n\n/* Ghost types */\n.pokemon-ghost {\n    background-color: #808080; \n}\n\n/* Dragon types */\n.pokemon-dragon {\n    background-color: #708090; \n}\n\n/* Dark types */\n.pokemon-dark {\n    background-color: #000000; \n}\n\n/* Steel types */\n.pokemon-steel {\n    background-color: #4682B4; \n}\n\n/* Fairy types */\n.pokemon-fairy {\n    background-color: #FFB6C1; \n}\n\n/* Normal types */\n.pokemon-normal {\n    background-color: #A9A9A9;\n}\n\n/* Ice types */\n.pokemon-ice {\n    background-color: #ADD8E6; \n}\n\n/* Grass types */\n.pokemon-grass {\n    background-color: #ACE894; \n}\n\n/* Navigation menu styling */\n\n.header {\n    width: 100%;\n    transition: .4s ease;\n    box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .3), 0 1px 3px 1px rgba(60, 64, 67, .15);\n}\n\n.header-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid var(--dark-gray);\n    background-color: #fff;\n    padding: 0px 20px;\n    height: 64px;\n    transition: .3s ease;\n}\n\n.links-to-pages,\n.account-section {\n    display: block;\n}\n\n.links-to-pages a {\n    color: var(--dark-gray);\n    font-family: 'Poppins' !important;\n    font-size: 16px;\n    font-weight: 500;\n    text-decoration: none;\n    padding: 8px 0;\n    margin: 0 15px;\n}\n\n.links-to-pages a:hover {\n    color: #000;\n}\n\n.links-to-pages .active-nav-menu-link {\n    border-bottom: 2px solid #4682B4 !important;\n    color: #000;\n}\n\n/* Styling the logo section */\n\n.landing-page-topbar-logo-section {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n\n/* Styling the logo in the logo section */\n\n.landing-page-topbar-logo-section .logo {\n    width: 135px;\n    display: flex;\n    align-items: center;\n}\n\n.landing-page-topbar-logo-section .logo img {\n    width: 100%;\n    padding: 8px;\n    border-radius: 4px;\n    transition: 0.2s ease;\n}\n\n.landing-page-topbar-logo-section .logo img:hover {\n    background-color: var(--white);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
